import AttributeFilter from './AttributeFilter';

export default AttributeFilter;
